import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { SimpleListAdapter, TS_DropDown } from '@nu-art/thunderstorm-frontend/index';
import { QuaiManager_DropDownCaret } from '@app/styles';
import { PopulationTypeLabelMap, PopulationTypes } from '@app/dp-shared';
export const Props_PopulationTypeDropDown = {
    adapter: () => SimpleListAdapter([...PopulationTypes], type => _jsx(_Fragment, { children: PopulationTypeLabelMap[type.item] })),
    placeholder: 'Pick Type',
    caret: QuaiManager_DropDownCaret,
};
export const DropDown_PopulationType = TS_DropDown.prepare(Props_PopulationTypeDropDown);
//# sourceMappingURL=ui-components.js.map